import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="girlsvolleyball.id" />
      <TextField source="girlsvolleyball.seasonWins" />
      <TextField source="girlsvolleyball.seasonLosses" />
      <TextField source="girlsvolleyball.seasonTies" />
      <TextField source="girlsvolleyball.seasonPercentWins" />
      <TextField source="girlsvolleyball.districtWins" />
      <TextField source="girlsvolleyball.districtLosses" />
      <TextField source="girlsvolleyball.districtTies" />
      <TextField source="girlsvolleyball.districtPercentWins" />
      <TextField source="girlsvolleyball.homeWins" />
      <TextField source="girlsvolleyball.homeLosses" />
      <TextField source="girlsvolleyball.homeTies" />
      <TextField source="girlsvolleyball.roadWins" />
      <TextField source="girlsvolleyball.roadLosses" />
      <TextField source="girlsvolleyball.roadTies" />
      <TextField source="girlsvolleyball.streak" />
      <TextField source="girlsvolleyball.differential" />
    </SimpleShowLayout>
  );
};

export default Tab;
